import * as React from 'react'
import { useFormikContext } from 'formik'

import Stack from '@mui/material/Stack'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import AlertTitle from '@mui/material/AlertTitle'

import {
  TidalProtectedFormikField,
  TidalTextFormikField,
} from '@sales-center/components'
import { ICallTrackingAccount } from '../typings'

type Props = {
  name: string
}

export function TidalCampaignTrackingForm(props: Props) {
  const { name } = props

  const { submitForm, status, isValid, isSubmitting } =
    useFormikContext<ICallTrackingAccount>()

  const isSyncError = status && status.message
  const errorMessage = `We are unable to Sync with  ${name}`
  const buttonDisabled = !isValid || isSubmitting
  return (
    <Stack
      gap={2}
      sx={{
        width: '100%',
      }}
    >
      <TidalTextFormikField required name="accountId" label="Account Id" />
      <TidalProtectedFormikField required name="accessKey" label="Access Key" />
      <TidalProtectedFormikField required name="secretKey" label="Secret Key" />
      {isSyncError && (
        <Alert severity="error">
          <AlertTitle>Sync Failed</AlertTitle>
          {errorMessage}
        </Alert>
      )}
      <Button
        onClick={submitForm}
        type="submit"
        variant="contained"
        size="large"
        disabled={buttonDisabled}
        sx={{
          textTransform: 'none',
        }}
      >
        Sync
      </Button>
    </Stack>
  )
}
